// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__K2Eue","icon":"SortAdornment_icon__24cBm","up":"SortAdornment_up__2qQrP","down":"SortAdornment_down__UxbfY","active":"SortAdornment_active__8fZX7"};